import { Component, Input } from '@angular/core';

@Component({
  selector: 'unh-spinner-progress',
  templateUrl: './spinner-progress.component.html',
  styleUrls: ['./spinner-progress.component.scss']
})
export class SpinnerProgressComponent  {
  @Input() value: any;
  @Input() diameter: number;
  @Input() loading = false;

  constructor() {
    this.diameter ? this.diameter : this.diameter = 100;
  }
}
